import { Component, OnInit, OnDestroy, HostListener, ViewChild, ElementRef } from '@angular/core';
import { ComunicadoService } from './service/comunicado.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-comunicado',
  templateUrl: './comunicado.component.html',
  styleUrls: ['./comunicado.component.css']
})
export class ComunicadoComponent implements OnInit, OnDestroy {
  @ViewChild('emailListContainer', { static: false }) emailListContainer: ElementRef;
  
  // Paginação
  paginaAtual = 1;
  quantidadeDePaginas = 1;
  totalDeRegistros = 0;
  itensPorPagina = 10;
  opcoesItensPorPagina = [10, 20, 30, 50, 100];
  
  // Dados
  todosComunicados: any[] = [];
  comunicadosFiltrados: any[] = [];
  
  // Estados da interface
  selecionado: any;
  incluindo = false;
  carregando = false;
  carregandoComunicado = false;
  ativaComunicado = true;
  fabrica = false;
  mostrarDropdownItens = false;
  
  // Pesquisa
  termoPesquisa = '';
  
  mostrarModalFiltros = false;
  filtros = {
    dataInicio: null as Date | null,
    dataFim: null as Date | null,
    assunto: '',
    remetente: '',
    tipoEnvio: null as number | null
  };
  
  opcoesTipoEnvio = [
    { label: 'Todos os tipos', value: null },
    { label: 'Portal', value: 0 },
    { label: 'Email', value: 1 },
    { label: 'Ambos', value: 2 }
  ]; 

  constructor(private service: ComunicadoService, private toast: ToastrService, private translate: TranslateService) { }

  get comunicadosParaExibir(): any[] {
    return this.comunicadosFiltrados;
  }

  get totalRegistrosAtual(): number {
    if (this.termoPesquisa && this.termoPesquisa.trim() !== '') {
      return this.totalDeRegistrosPesquisa;
    }
    return this.totalDeRegistros;
  }

  get totalPaginasAtual(): number {
    if (this.termoPesquisa && this.termoPesquisa.trim() !== '') {
      return this.quantidadeDePaginasPesquisa;
    }
    return this.quantidadeDePaginas;
  }

  private totalDeRegistrosPesquisa = 0;
  private quantidadeDePaginasPesquisa = 1;
  private comunicadosPesquisados: any[] = [];

  ngOnInit() {
    this.carregando = true;
    this.carregarLista(1);
    
    this.service.verificarNotificacao()
      .catch(erro => {
        console.error('Erro ao verificar notificação ao entrar na página:', erro);
      });
  }

  ngOnDestroy() {
    this.todosComunicados = [];
    this.comunicadosFiltrados = [];
    this.selecionado = null;
    
    this.service.resetarEstadoEndpoint();
  }

  private carregarLista(pagina: number) {
    this.carregando = true;
    this.todosComunicados = [];
    this.comunicadosFiltrados = [];
    this.selecionado = null;
    
    const filtros = this.prepararFiltros();
    
    this.service.buscarComunicados(filtros)
      .then(res => {
        this.todosComunicados = res.dados.map(item => ({
          ...item,
          id: item.id_comunicado,
          enviado: item.data_envio
        }));
        
        this.todosComunicados.sort((a, b) => {
          const dateA = new Date(a.data_envio.replace(/\[UTC\]$/, ''));
          const dateB = new Date(b.data_envio.replace(/\[UTC\]$/, ''));
          return dateB.getTime() - dateA.getTime();
        });
        
        this.totalDeRegistros = this.todosComunicados.length;
        this.quantidadeDePaginas = Math.ceil(this.totalDeRegistros / this.itensPorPagina);
        this.paginaAtual = pagina;
        
        this.aplicarPaginacao();
        
        this.fabrica = res.fabrica !== undefined ? res.fabrica : true; 
        this.carregando = false;
        
        this.verificarEAtualizarEstadoNotificacao();
        
        this.scrollToTop();
      })
      .catch(error => {
        this.translate.get('comunicado.erro.erroCarregarLista').subscribe(text => {
          this.toast.error(text, this.translate.instant('comunicado.erro.erroInesperado'));
        });
        this.carregando = false;
      });
  }

  private aplicarPaginacao(): void {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    const fim = inicio + this.itensPorPagina;
    this.comunicadosFiltrados = this.todosComunicados.slice(inicio, fim);
  }

  public exibir(id: number) {
    if (!this.incluindo) {
      this.carregandoComunicado = true;
      this.selecionado = null; 
      
      this.service.oberPeloId(id)
        .then(res => {
          this.selecionado = res.dados[0];
          if (this.selecionado) {
            this.selecionado.id = this.selecionado.id_comunicado;
            this.selecionado.enviado = this.selecionado.data_envio;
            this.selecionado.lido = true;
          }
          
          const item = this.todosComunicados.find(p => p.id_comunicado === id);
          if (item) {
            item.lido = true;
          }

          this.verificarEAtualizarEstadoNotificacao();
          
          this.carregandoComunicado = false;
        })
        .catch(error => {
          this.translate.get('comunicado.erro.erroCarregarComunicado').subscribe(text => {
            this.toast.error(text, this.translate.instant('comunicado.erro.erroInesperado'));
          });
          this.carregandoComunicado = false;
        });
    }
  }

  public getEstado(): boolean {
    return this.incluindo;
  }

  public setEstado(value: boolean) {
    this.incluindo = value;
  }

  public novoComunicado(): void {
    this.incluindo = true;
    this.selecionado = null;
  }

  public setEstadoComunicado(estado: boolean): void {
    this.ativaComunicado = estado;
  }

  public irParaPagina(pagina: number): void {
    const maxPaginas = this.totalPaginasAtual;
    const value = pagina <= 0 ? 1 : pagina > maxPaginas ? maxPaginas : pagina;
    this.paginaAtual = value;
    
    // Se há pesquisa ativa, paginar resultados da pesquisa
    if (this.termoPesquisa && this.termoPesquisa.trim() !== '') {
      this.aplicarPaginacaoPesquisa();
    } else {
      this.aplicarPaginacao();
    }
    
    this.scrollToTop();
  }

  marcarComoNaoLido(selecionado: any): void {
    this.service.marcarComoNaoLido(selecionado.id_comunicado || selecionado.id)
      .then(res => {
        this.translate.get('comunicado.lista.marcadoComoNaoLido').subscribe(text => {
          this.toast.info(text, 'Informação');
        });

        selecionado.lido = false;

        const idComunicado = selecionado.id_comunicado || selecionado.id;
        const item = this.todosComunicados.find(p => (p.id_comunicado || p.id) === idComunicado);
        if (item) {
          item.lido = false;
        }

        this.verificarEAtualizarEstadoNotificacao();
      })
      .catch(erro => {
        this.translate.get('comunicado.erro.erroMarcarNaoLido').subscribe(text => {
          this.toast.error(text, this.translate.instant('comunicado.erro.erroInesperado'));
        });
      });
  }

  marcarComoLido(id: number): void {
    const item = this.todosComunicados.find(p => (p.id_comunicado || p.id) === id);
    if (item) {
      item.lido = true;
    }
    
    if (this.selecionado && (this.selecionado.id_comunicado || this.selecionado.id) === id) {
      this.selecionado.lido = true;
    }

    this.verificarEAtualizarEstadoNotificacao();
  }

  refreshComunicados(): void {
    if (!this.carregando) {
      this.carregarLista(this.paginaAtual);
      
      this.service.verificarNotificacao()
        .catch(erro => {
          console.error('Erro ao verificar notificação após refresh:', erro);
        });
    }
  }

  pesquisarComunicados(): void {
    if (!this.termoPesquisa || this.termoPesquisa.trim() === '') {
      this.paginaAtual = 1;
      this.aplicarPaginacao();
      return;
    }

    const termo = this.termoPesquisa.toLowerCase().trim();
    
    this.comunicadosPesquisados = this.todosComunicados.filter(comunicado => {
      const tituloMatch = comunicado.assunto && comunicado.assunto.toLowerCase().includes(termo);
      
      const conteudoMatch = comunicado.conteudo && comunicado.conteudo.toLowerCase().includes(termo);
      
      const remetenteMatch = comunicado.remetente && 
        comunicado.remetente.nome && 
        comunicado.remetente.nome.toLowerCase().includes(termo);
      
      return tituloMatch || conteudoMatch || remetenteMatch;
    });

    this.totalDeRegistrosPesquisa = this.comunicadosPesquisados.length;
    this.quantidadeDePaginasPesquisa = Math.ceil(this.totalDeRegistrosPesquisa / this.itensPorPagina);
    this.paginaAtual = 1; 

    this.aplicarPaginacaoPesquisa();
  }

  private aplicarPaginacaoPesquisa(): void {
    const inicio = (this.paginaAtual - 1) * this.itensPorPagina;
    const fim = inicio + this.itensPorPagina;
    this.comunicadosFiltrados = this.comunicadosPesquisados.slice(inicio, fim);
  }

  limparPesquisa(): void {
    this.termoPesquisa = '';
    this.paginaAtual = 1;
    this.aplicarPaginacao();
  }

  alterarItensPorPagina(novoLimite: number): void {
    this.itensPorPagina = novoLimite;
    this.paginaAtual = 1; 
    this.mostrarDropdownItens = false; 
    
    if (this.termoPesquisa && this.termoPesquisa.trim() !== '') {
      this.quantidadeDePaginasPesquisa = Math.ceil(this.totalDeRegistrosPesquisa / this.itensPorPagina);
      this.aplicarPaginacaoPesquisa();
    } else {
      this.quantidadeDePaginas = Math.ceil(this.totalDeRegistros / this.itensPorPagina);
      this.aplicarPaginacao();
    }
    
    this.scrollToTop();
  }

  toggleItensPorPaginaDropdown(): void {
    this.mostrarDropdownItens = !this.mostrarDropdownItens;
  }

  abrirModalFiltros(): void {
    this.mostrarModalFiltros = true;
  }

  fecharModalFiltros(): void {
    this.mostrarModalFiltros = false;
  }

  limparFiltros(): void {
    this.filtros = {
      dataInicio: null,
      dataFim: null,
      assunto: '',
      remetente: '',
      tipoEnvio: null
    };
  }

  aplicarFiltros(): void {
    this.carregando = true;
    this.paginaAtual = 1;
    this.fecharModalFiltros();
    this.carregarLista(1);
  }

  limparFiltrosRapido(event: Event): void {
    event.stopPropagation();
    this.limparFiltros();
    this.carregando = true;
    this.paginaAtual = 1;
    this.carregarLista(1);
  }

  private prepararFiltros(): any {
    const filtros: any = {};
    
    if (this.filtros.dataInicio) {
      filtros.dataInicio = this.formatarDataParaAPI(this.filtros.dataInicio);
    }
    if (this.filtros.dataFim) {
      filtros.dataFim = this.formatarDataParaAPI(this.filtros.dataFim);
    }

    if (this.filtros.assunto && this.filtros.assunto.trim()) {
      filtros.assunto = this.filtros.assunto.trim();
    }

    if (this.filtros.remetente && this.filtros.remetente.trim()) {
      filtros.remetente = this.filtros.remetente.trim();
    }
    
    if (this.filtros.tipoEnvio !== null && this.filtros.tipoEnvio !== undefined) {
      filtros.tipoEnvio = this.filtros.tipoEnvio;
    }
    
    return filtros;
  }

  public temFiltrosAplicados(): boolean {
    return !!(
      this.filtros.dataInicio ||
      this.filtros.dataFim ||
      (this.filtros.assunto && this.filtros.assunto.trim()) ||
      (this.filtros.remetente && this.filtros.remetente.trim()) ||
      (this.filtros.tipoEnvio !== null && this.filtros.tipoEnvio !== undefined)
    );
  }

  private formatarDataParaAPI(data: Date): string {
    if (!data) return '';
    
    const year = data.getFullYear();
    const month = String(data.getMonth() + 1).padStart(2, '0');
    const day = String(data.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }

  private scrollToTop(): void {
    setTimeout(() => {
      if (this.emailListContainer && this.emailListContainer.nativeElement) {
        this.emailListContainer.nativeElement.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }, 0);
  }

  @HostListener('document:click', ['$event'])
  fecharDropdownAoClicarFora(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const clickedInside = target.closest('.items-config-wrapper');
    
    if (!clickedInside && this.mostrarDropdownItens) {
      this.mostrarDropdownItens = false;
    }
  }

  /**
   * Verifica se há comunicados não lidos e atualiza o estado de notificação
   * no serviço. Isso faz com que o badge de notificação apareça/desapareça
   * automaticamente no botão de comunicado do menu principal.
   * 
   * Combina duas fontes de informação:
   * 1. Lista local de comunicados (fonte da verdade principal)
   * 2. Endpoint /comunicado/notificacao (para novos comunicados não carregados ainda)
   */
  private verificarEAtualizarEstadoNotificacao(): void {
    const temNaoLidos = this.service.verificarComunicadosNaoLidos(this.todosComunicados);
    
    if (!temNaoLidos) {
      this.service.resetarEstadoEndpoint();
    }
    
    this.service.atualizarEstadoNotificacao(temNaoLidos);
  }
}
